module.exports = __webpack_public_path__ + "img/9.fcaaea44.jpg";